/**
 * Custom scripts — o.a. product card price formatting (integer 24px, decimalen 16px).
 * Draait op load en bij dynamisch toegevoegde product cards (infinite scroll, variant update).
 */

/**
 * Splits prijstekst in integer- en decimalendeel en wrapt decimalen in span.price__decimals.
 * Ondersteunt o.a. "89,95", "89.95", "1.234,56", "1,234.56".
 * @param {HTMLElement} priceEl - Element met class "price" dat de ruwe prijstekst bevat
 */
function formatProductCardPrice(priceEl) {
  if (!priceEl || priceEl.querySelector('.price__decimals')) return;
  const text = priceEl.textContent?.trim() || '';
  const match = text.match(/^(.*?)(\d[\d.,]*)([,.])(\d{2,3})$/);
  if (!match) return;
  const [, currency, integerPart, separator, decimalPart] = match;

  priceEl.textContent = '';

  if (currency.trim()) {
    const currencySpan = document.createElement('span');
    currencySpan.className = 'price__currency';
    currencySpan.textContent = currency;
    priceEl.appendChild(currencySpan);
  }

  priceEl.appendChild(document.createTextNode(integerPart + separator));

  const decimalsSpan = document.createElement('span');
  decimalsSpan.className = 'price__decimals';
  decimalsSpan.setAttribute('aria-hidden', 'true');
  decimalsSpan.textContent = decimalPart;
  priceEl.appendChild(decimalsSpan);
}

/**
 * Formatteer alle .price elementen binnen product cards die nog geen .price__decimals hebben.
 * @param {ParentNode} root - Scope (default: document)
 */
function formatAllProductCardPrices(root = document) {
  root.querySelectorAll?.('.product-card product-price :is(.price, .compare-at-price):not(:has(.price__decimals))').forEach(formatProductCardPrice);
}

function init() {
  formatAllProductCardPrices();
  /* Bij dynamisch toegevoegde cards (infinite scroll, etc.) */
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.addedNodes.length) {
        m.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            formatAllProductCardPrices(node);
            /* Prijs die net is vervangen (variant update) zit in toegevoegde container */
            node.querySelectorAll?.('.price, .compare-at-price').forEach((el) => {
              if (el.closest('.product-card product-price') && !el.querySelector('.price__decimals')) {
                formatProductCardPrice(el);
              }
            });
          }
        });
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
